export function shallowCompareObjects(o1 = {}, o2 = {}) {
    // Function to compare objects in first level, checks primitives by value and object by reference
    return (
        o1 === o2 ||
        (Object.keys(o1).length === Object.keys(o2).length &&
            Object.keys(o1).every((p) => o1[p] === o2[p]))
    );
}

export default shallowCompareObjects;
